import { useState } from "react";
import styled from "styled-components";
import Pin1 from "../assets/images/pin1.svg";
import Pin2 from "../assets/images/pin2.svg";
import { Link } from "@reach/router";
import { t } from "../lang";

const IndividualRegistration = (props: any) => {
  const data = {
    items: [
      {
        id: "location",
        title: "Pick location",
        icon: Pin1,
      },
    ],
  };

  const [state, setstate] = useState(data);
  return (
    <Container className="Container">
      <Title className="Title">{t('Location?')}</Title>
      <Content className="Content">
        {state.items.map((item) => (
          <Link to={`/industry_city`}>
            <Item key={item.id} className="Item">
              <ItemIcon className="ItemIcon" src={item.icon} />
              <ItemTitle className="ItemTitle">{t(item.title)}</ItemTitle>
            </Item>
          </Link>
        ))}
      </Content>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  height: 100vh;
  width: 100vw;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const Content = styled.div``;
const Item = styled.div`
  background: #182a33;
  cursor: pointer;
  border-radius: 67px;

  display: flex;
  justify-content: center;
  align-items: center;
  margin: 2px 23px;
  &:hover {
    background: #cfb636;
    color: #182a33;
  }
`;

const Title = styled.h1`
  font-size: 2.5em;
`;
const ItemTitle = styled.h2`
  font-size: 2em;
  margin-right: 25px;
`;
const ItemIcon = styled.img`
  height: 40px;
  margin: 2px 23px;
`;

export default IndividualRegistration;
